import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const CreateTestimonial = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    project_id: '',
    message: '',
    rating: 5,
    video_link: '',
    image: null,
    is_active: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === 'file') {
      setFormData((prev) => ({
        ...prev,
        [name]: files && files.length > 0 ? files[0] : null,
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim() || !formData.message.trim()) {
      toast.error('Name and message are required');
      return;
    }

    const ratingInt = parseInt(formData.rating, 10);
    if (Number.isNaN(ratingInt) || ratingInt < 1 || ratingInt > 5) {
      toast.error('Rating must be between 1 and 5');
      return;
    }

    setLoading(true);

    const payload = new FormData();
    payload.append('name', formData.name.trim());
    payload.append('project_id', formData.project_id.trim());
    payload.append('message', formData.message.trim());
    payload.append('rating', String(ratingInt));
    payload.append('video_link', formData.video_link.trim());
    payload.append('is_active', formData.is_active ? 'true' : 'false');

    if (formData.image) {
      payload.append('image', formData.image);
    }

    try {
      const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
      const response = await postRequest('testimonials', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response?.data?.success) {
        toast.success('Testimonial created successfully');
        navigate('/testimonials');
      } else {
        toast.error(response?.data?.message || 'Failed to create testimonial');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to create testimonial');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="font-weight-bold">Add New Testimonial</h4>
      </div>

      <form onSubmit={handleSubmit} className="form-style">
        <div className="row mx-4 mt-5">
          <div className="col-md-6 mt-2">
            <label htmlFor="name">Name *</label>
            <input
              id="name"
              name="name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="project_id">Project ID (optional)</label>
            <input
              id="project_id"
              name="project_id"
              className="form-control"
              value={formData.project_id}
              onChange={handleChange}
              placeholder="e.g. PRJ-101"
            />
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="rating">Rating (1-5) *</label>
            <select
              id="rating"
              name="rating"
              className="form-control"
              value={formData.rating}
              onChange={handleChange}
              required
            >
              <option value="1">1 - Poor</option>
              <option value="2">2 - Fair</option>
              <option value="3">3 - Good</option>
              <option value="4">4 - Very Good</option>
              <option value="5">5 - Excellent</option>
            </select>
          </div>

          <div className="col-md-6 mt-2">
            <label htmlFor="image">Image (optional)</label>
            <input
              id="image"
              name="image"
              type="file"
              className="form-control-file"
              accept="image/*"
              onChange={handleChange}
            />
            {formData.image && (
              <small className="text-muted d-block mt-1">Selected: {formData.image.name}</small>
            )}
          </div>

          <div className="col-12 mt-2">
            <label htmlFor="message">Message *</label>
            <textarea
              id="message"
              name="message"
              rows="5"
              className="form-control"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-12 mt-2">
            <label htmlFor="video_link">Video Link (optional)</label>
            <input
              id="video_link"
              name="video_link"
              className="form-control"
              value={formData.video_link}
              onChange={handleChange}
              placeholder="https://youtube.com/..."
            />
          </div>

          <div className="col-12 mt-2 form-check">
            <input
              type="checkbox"
              id="is_active"
              name="is_active"
              className="form-check-input"
              checked={formData.is_active}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="is_active">
              Active (show on website)
            </label>
          </div>
        </div>

        <div className="mt-5 text-right mx-4">
          <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
            {loading ? 'Creating...' : 'Create Testimonial'}
          </button>
        </div>
      </form>
    </div >
  );
};

export default CreateTestimonial;
